"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-1bca66f9"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bgc" }, null, -1));
const _hoisted_2 = { class: "max-content" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "header" };
const _hoisted_5 = { class: "title" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "MBOM", -1));
const _hoisted_7 = { class: "func" };
const _hoisted_8 = { class: "tableContent" };
const _hoisted_9 = { class: "quickSelect" };
const _hoisted_10 = { class: "selectL" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, "物料层级快捷筛选：", -1));
const _hoisted_12 = { class: "Lblock" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "L0" }, "L0", -1));
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "selectL" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, "查找子项物料：", -1));
const _hoisted_17 = { class: "searchWuLiao" };
const _hoisted_18 = { class: "searchBoxContent" };
const _hoisted_19 = { class: "selectTable" };
const _hoisted_20 = { class: "btnContent" };
const _hoisted_21 = { class: "mbomTable" };
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const mbomSercive_1 = require("../../service/mbomSercive");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const route = (0, vue_router_1.useRoute)();
        const tableData = (0, vue_3.ref)([]);
        const selectTableData = (0, vue_3.ref)([]);
        const chooseList = (0, vue_3.reactive)([]);
        const showSelect = (0, vue_3.ref)(false);
        const allRowKey = (0, vue_3.ref)([]);
        const checked = (0, vue_3.ref)(false);
        const selectRows = (0, vue_3.ref)([]);
        let tableDataAll = []; //初始查到的所有MBOM数据
        const rowSelection = (0, vue_3.ref)({
            checkStrictly: false,
            selectedRowKeys: [],
            onChange: (selectedRowKeys, selectedRows) => {
                rowSelection.value.selectedRowKeys = selectedRowKeys;
                selectRows.value = selectedRows;
                //如果当前所有行的key不等于选中的key说明没有全选，取消全选checkbox的勾选，否则全选
                if (allRowKey.value.length !== selectedRowKeys.length) {
                    checked.value = false;
                }
                else {
                    checked.value = true;
                }
            }
        });
        const setTableDataAll = (res) => {
            var _a;
            tableDataAll = (_a = res.data) === null || _a === void 0 ? void 0 : _a.map((item, index) => {
                return Object.assign(Object.assign({}, item), { serial: index + 1 });
            });
            if (tableDataAll) {
                tableData.value = tableDataAll;
            }
        };
        const setSelectTableData = (res) => {
            selectTableData.value = res.data.map((item, index) => {
                return Object.assign(Object.assign({}, item), { serial: index + 1 });
            });
            allRowKey.value = selectTableData.value.map((item) => item.serial);
        };
        const changeSelect = () => {
            tableDataAll = selectRows.value;
            tableData.value = tableDataAll;
        };
        const inputChange = (value) => __awaiter(this, void 0, void 0, function* () {
            checked.value = false;
            rowSelection.value.selectedRowKeys = [];
            const res = yield (0, mbomSercive_1.searchMBOMKey)(route.query.SN, value);
            setSelectTableData(res);
        });
        const selectAll = (e) => {
            if (e.target.checked) {
                rowSelection.value.selectedRowKeys = allRowKey.value;
                selectRows.value = selectTableData.value;
            }
            else {
                rowSelection.value.selectedRowKeys = [];
                selectRows.value = [];
            }
        };
        const getSelectState = (isFocus) => {
            if (isFocus) {
                showSelect.value = true;
            }
            else {
                showSelect.value = false;
            }
        };
        const handleChange = (value) => {
            console.log(`selected ${value}`);
        };
        const goBack = () => {
            router.push({
                path: '/productionInfo',
                query: {
                    SN: route.query.SN,
                    stakeQRCode: route.query.stakeQRCode
                }
            });
        };
        const chooseListFilter = (chooseList) => {
            if (tableDataAll) {
                if ((chooseList === null || chooseList === void 0 ? void 0 : chooseList.length) === 0) {
                    tableData.value = tableDataAll;
                }
                else {
                    tableData.value = tableDataAll.filter((item) => {
                        return chooseList.includes(item.zixiangwuliaocengji);
                    }).map((item, index) => {
                        return Object.assign(Object.assign({}, item), { serial: index + 1 });
                    });
                }
            }
        };
        const chooseL = (L) => {
            if (chooseList.includes(L)) {
                const index = chooseList.indexOf(L);
                chooseList.splice(index, 1);
            }
            else {
                chooseList.push(L);
            }
            chooseListFilter(chooseList);
        };
        (0, vue_3.onMounted)(() => __awaiter(this, void 0, void 0, function* () {
            const res = yield (0, mbomSercive_1.searchMBOMKey)(route.query.SN, '');
            setTableDataAll(res);
            setSelectTableData(res);
        }));
        const columns = [
            { "title": "序号", "dataIndex": "serial", "key": "serial" },
            { "title": "子项物料编码", "dataIndex": "zixiangwuliaobianma", "key": "zixiangwuliaobianma" },
            { "title": "子项物料名称", "dataIndex": "zixiangwuliaomingcheng", "key": "zixiangwuliaomingcheng" },
            { "title": "子项物料层级", "dataIndex": "zixiangwuliaocengji", "key": "zixiangwuliaocengji" },
            { "title": "子项物料SN码", "dataIndex": "zixiangwuliaosnma", "key": "zixiangwuliaosnma" },
            { "title": "料号", "dataIndex": "liaohao", "key": "liaohao" },
            { "title": "批次", "dataIndex": "pici", "key": "pici" },
            { "title": "供应商", "dataIndex": "gongyingshang", "key": "gongyingshang" },
            { "title": "规格型号", "dataIndex": "guigexinghao", "key": "guigexinghao" },
            { "title": "规格型号描述", "dataIndex": "guigexinghaomiaoshu", "key": "guigexinghaomiaoshu" },
            { "title": "子项类型", "dataIndex": "zixiangleixing", "key": "zixiangleixing" },
            { "title": "单位", "dataIndex": "danwei", "key": "danwei" },
            { "title": "子项用量", "dataIndex": "zixiangyongliang", "key": "zixiangyongliang" },
            { "title": "替代方案", "dataIndex": "tidaifangan", "key": "tidaifangan" },
            { "title": "优先级", "dataIndex": "youxianji", "key": "youxianji" },
            { "title": "使用概率", "dataIndex": "shiyonggaishuai", "key": "shiyonggaishuai" },
            { "title": "父项物料编码", "dataIndex": "fuxiangwuliaobianma", "key": "fuxiangwuliaobianma" },
            { "title": "父项物料名称", "dataIndex": "fuxiangwuliaomingcheng", "key": "fuxiangwuliaomingcheng" },
        ];
        return (_ctx, _cache) => {
            var _a, _b;
            const _component_Header = (0, vue_2.resolveComponent)("Header");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            const _component_SearchBox = (0, vue_2.resolveComponent)("SearchBox");
            const _component_a_checkbox = (0, vue_2.resolveComponent)("a-checkbox");
            const _component_a_table = (0, vue_2.resolveComponent)("a-table");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (0, vue_2.createVNode)(_component_Header),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("span", null, "MBOM时间戳：" + (0, vue_2.toDisplayString)(((_a = tableData.value[0]) === null || _a === void 0 ? void 0 : _a.mbomshijianchuoyongliaodan) || '--'), 1),
                                (0, vue_2.createElementVNode)("span", null, "MBOM版本号：" + (0, vue_2.toDisplayString)(((_b = tableData.value[0]) === null || _b === void 0 ? void 0 : _b.mbombanben) || '--'), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createVNode)(_component_a_button, {
                                    class: "back",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (goBack()))
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("返回")
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                    _hoisted_11,
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        _hoisted_13,
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)([{
                                                id: 'L1',
                                                value: 'L1'
                                            }, {
                                                id: 'L2',
                                                value: 'L2'
                                            }], (item) => {
                                            return (0, vue_2.createElementVNode)("div", {
                                                onClick: ($event) => (chooseL(item.value)),
                                                class: (0, vue_2.normalizeClass)(chooseList.includes(item.value) ? 'choose' : ''),
                                                key: item.id
                                            }, (0, vue_2.toDisplayString)(item.value), 11, _hoisted_14);
                                        }), 64))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                    _hoisted_16,
                                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                            (0, vue_2.createVNode)(_component_SearchBox, {
                                                placeholder: "请输入子项物料编码/子项物料名称",
                                                width: '300px',
                                                inputChange: inputChange,
                                                handleChange: handleChange,
                                                canOpen: false,
                                                onGetSelectState: getSelectState,
                                                showSelect: showSelect.value
                                            }, null, 8, ["showSelect"])
                                        ]),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_19, [
                                            (0, vue_2.createVNode)(_component_a_checkbox, {
                                                class: "selectAll",
                                                checked: checked.value,
                                                "onUpdate:checked": _cache[1] || (_cache[1] = ($event) => ((checked).value = $event)),
                                                onChange: selectAll
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)("全选")
                                                ]),
                                                _: 1
                                            }, 8, ["checked"]),
                                            (0, vue_2.createVNode)(_component_a_table, {
                                                showHeader: false,
                                                columns: [{
                                                        title: '子项物料编码',
                                                        dataIndex: 'zixiangwuliaobianma',
                                                        key: 'zixiangwuliaobianma',
                                                    }, {
                                                        title: '子项物料名称',
                                                        dataIndex: 'zixiangwuliaomingcheng',
                                                        key: 'zixiangwuliaomingcheng',
                                                    }],
                                                "data-source": selectTableData.value,
                                                "row-selection": rowSelection.value,
                                                "row-key": (record) => record.serial,
                                                scroll: { y: '350px' }
                                            }, null, 8, ["data-source", "row-selection", "row-key"]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                                (0, vue_2.createVNode)(_component_a_button, {
                                                    class: "cancel",
                                                    onClick: _cache[2] || (_cache[2] = () => {
                                                        showSelect.value = false;
                                                    })
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)("取消")
                                                    ]),
                                                    _: 1
                                                }),
                                                (0, vue_2.createVNode)(_component_a_button, {
                                                    class: "confirm",
                                                    onClick: changeSelect
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)("确定")
                                                    ]),
                                                    _: 1
                                                })
                                            ])
                                        ], 512), [
                                            [vue_2.vShow, showSelect.value]
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                (0, vue_2.createVNode)(_component_a_table, {
                                    columns: columns,
                                    "data-source": tableData.value,
                                    scroll: { x: 'max-content', scrollToFirstRowOnChange: true },
                                    pagination: {
                                        locale: {
                                            items_per_page: '/ 页',
                                        }
                                    }
                                }, null, 8, ["data-source"])
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
